/**
 * @license
 * @copyright Copyright Motili Inc., 2026 All Rights Reserved
 */

import { ReactNode } from 'react';
import classNames from 'classnames';
import styles from './ActiveFilterContainer.module.scss';

interface ActiveFilterContainerProps {
    children: ReactNode;
    clearable?: boolean;
}

const ActiveFilterContainer = ({
    children,
    clearable = true,
}: ActiveFilterContainerProps) => (
    <div
        className={classNames(styles.activeFilterContainer, {
            [styles.clearable]: clearable,
        })}
    >
        {children}
    </div>
);

export default ActiveFilterContainer;
